import { LogOutIcon, SettingsIcon, ShieldIcon } from "lucide-react";
import { useNavigate } from "@tanstack/react-router";

import { useAccess } from "../../access/AccessProvider";
import { useOperatorsAuth } from "../../operatorsAuth";
import { Menu, MenuItem, MenuPopup, MenuSeparator, MenuTrigger } from "~/components/ui/menu";

function UserAvatarButton(props: {
  name: string | null | undefined;
  email: string | null | undefined;
}) {
  const initials = (props.name?.trim() || props.email?.trim() || "?").slice(0, 1).toUpperCase();

  return (
    <span className="inline-flex size-8 shrink-0 items-center justify-center rounded-full border border-border/80 bg-secondary/50 text-xs font-medium text-foreground">
      {initials}
    </span>
  );
}

function formatRoleLabel(role: string): string {
  return role.replaceAll("_", " ");
}

export function AppUserMenu() {
  const navigate = useNavigate();
  const { logout, user } = useOperatorsAuth();
  const { isSuperAdmin, roles } = useAccess();

  return (
    <Menu>
      <MenuTrigger
        aria-label="User menu"
        className="flex size-10 shrink-0 items-center justify-center rounded-lg hover:bg-accent outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        <UserAvatarButton name={user?.name} email={user?.email} />
      </MenuTrigger>
      <MenuPopup align="start" side="top" className="min-w-52">
        {user ? (
          <>
            <div className="px-2 py-1.5">
              <p className="truncate text-sm font-medium text-foreground">{user.name}</p>
              <p className="truncate text-xs text-muted-foreground">{user.email}</p>
              <p className="mt-1 truncate text-[11px] text-muted-foreground">
                {[...roles].map(formatRoleLabel).join(" · ") || "member"}
                {isSuperAdmin ? " · super admin" : ""}
              </p>
            </div>
            <MenuSeparator />
          </>
        ) : null}
        <MenuItem
          onClick={() => {
            void navigate({ to: "/settings" });
          }}
        >
          <SettingsIcon className="size-4" />
          Settings
        </MenuItem>
        {isSuperAdmin ? (
          <MenuItem
            onClick={() => {
              void navigate({ to: "/settings/admin" });
            }}
          >
            <ShieldIcon className="size-4" />
            Admin
          </MenuItem>
        ) : null}
        <MenuItem
          onClick={() => {
            void logout();
          }}
        >
          <LogOutIcon className="size-4" />
          Sign out
        </MenuItem>
      </MenuPopup>
    </Menu>
  );
}
